import { render, staticRenderFns } from "./standardRiskText.vue?vue&type=template&id=40bce8ab&"
import script from "./standardRiskText.vue?vue&type=script&lang=js&"
export * from "./standardRiskText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports